export class GlobalConstants {
    public static path_list: Array<string> = ['/home', '/my-account', '/test', '/waybill/waybill-rate-calculation', '/videoplayer', '/trip/return-shipment', '/finance/10344'];
    public static isConnected: boolean;
}
